export default __webpack_public_path__ + "locales/hy-AM/Common.json?hash=dc60104cfd5ae313c5fcf5a50bb23d00";